import React, { useState, useCallback } from 'react';

import config from 'config';
import { defineMessages } from 'react-intl';
import styled, { css } from 'styled-components';

import FableticsModal from '~/shared/components/FableticsModal';
import { getBrandValue } from '~/shared/utils/brandNameHelper';
import { getLocalizedRbKey } from '~/shared/utils/getLocalizedRbKey';
import useMembershipPrice from '~/shared/utils/useMembershipPrice';
import { Link } from '~/techstyle-shared/next-routes';
import { AssetContainer } from '~/techstyle-shared/react-assets';
import { useBreakpoint } from '~/techstyle-shared/react-components';
import {
  useIntl,
  FormattedMessage,
  useGeoCountry,
} from '~/techstyle-shared/react-intl';
import { useDomain } from '~/techstyle-shared/redux-core';

const Wrapper = styled.div`
  ${({ theme }) => theme.pdpStyles.vipOptIn.vipOptInMessageWrapper};
`;

const ModalLink = styled.a`
  margin-top: 16px;

  ${({ theme }) => theme.pdpStyles.vipOptIn.modalLink};
`;

const contentWrapperStyles = css`
  ${({ theme }) => theme.vipOptInModal.contentWrapperStyles}
`;

const VIPOptInModal = styled(FableticsModal)`
  ${({ theme }) => theme.vipOptInModal.modalStyles}
`;

const transitionProps = {
  enter: { opacity: 1, transform: 'scale(1, 1)' },
  from: { opacity: 0, transform: 'scale(0.5, 0.5)' },
  leave: { opacity: 0, transform: 'scale(0.5, 0.5)' },
};

const messages = defineMessages({
  learnMore: {
    id: 'pdp_membership_select.learn_more',
    defaultMessage: 'Learn more about our VIP membership',
  },
});

const DynamicFormattedMessage = FormattedMessage;

const globalMembershipPrice = config.get('public.brand.globalMembershipPrice');

function VIPOptInMessage() {
  const price = useMembershipPrice();

  const geoCountry = useGeoCountry();

  const { tld } = useDomain();
  const membershipPrice = useMembershipPrice({ asCurrency: true });
  const intl = useIntl();
  const howItWorksLink = config.get('public.brand.howItWorksLink');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isMobile } = useBreakpoint();
  const learnMoreAsset = isMobile
    ? config.get('public.brand.learnMorePopup.mobile')
    : config.get('public.brand.learnMorePopup.desktop');

  const updatedLearnMoreAsset = getBrandValue({
    savage:
      price && globalMembershipPrice && price !== globalMembershipPrice[tld]
        ? learnMoreAsset
        : `${learnMoreAsset}_69`,
    default: learnMoreAsset,
  });

  const handleModalOpen = useCallback((event) => {
    event.preventDefault();
    setIsModalOpen(true);
  }, []);

  return (
    <Wrapper>
      <DynamicFormattedMessage
        id={getLocalizedRbKey(
          'pdp_membership_select.vip_disclosure_v2',
          geoCountry
        )}
        defaultMessage="After your first purchase, you will be charged {membershipPrice} each month for a Member Credit, unless you “Skip” between the 1st and the 5th. You have 12 months to redeem each credit for any item or outfit up to $80, before the credit expires. Cancel your membership anytime online or by phone."
        values={{
          membershipPrice,
        }}
      />
      <Link href={howItWorksLink}>
        <ModalLink
          onClick={handleModalOpen}
          data-autotag="pdp-learn-more-membership-link"
        >
          <DynamicFormattedMessage
            id={getLocalizedRbKey(
              'pdp_membership_select.learn_more',
              geoCountry
            )}
            defaultMessage="Learn more about our VIP membership"
          />
        </ModalLink>
      </Link>
      <VIPOptInModal
        title={intl.formatMessage(messages.learnMore)}
        isOpen={isModalOpen}
        onExit={() => setIsModalOpen(false)}
        transitionEnter={transitionProps.enter}
        transitionFrom={transitionProps.from}
        transitionLeave={transitionProps.leave}
        showCloseButton
        contentWrapperStyles={contentWrapperStyles}
      >
        <AssetContainer name={updatedLearnMoreAsset} aspectRatio="auto" />
      </VIPOptInModal>
    </Wrapper>
  );
}

export default VIPOptInMessage;
